import fetch from '@/utils/fetch'

// 合作伙伴-首页查询
export function getPartnerList(params) {
    return fetch({
        url: '/por-basis/por/basis/partner/queryPartnerList',
        method: 'get',
        params
    })
}

// 获取轮播图
export const getSwiper = (params) => {
    return fetch({
      url: '/por-basis/por/basis/pollings/getPollingInitializationRule',
      method: 'get',
      params
    })
  }

// 获取首页数据
export const queryPlatformDataInfo = (params) => {
  return fetch({
    url: '/por-basis/por/basis/getdatadict/queryPlatformDataInfo',
    method: 'get',
    params
  })
}
// 获取数据字典内容
export const getDictListByTypeKey = (params) => {
  return fetch({
      url: '/por-basis/por/basis/dict/getDictListByTypeKey',
      method: 'get',
      params
  })
}
